import { useEffect, useState } from "react";
import useQuery from "../utils/UseQuery";
import { ClipLoader } from "react-spinners";
import { ButtonStyle } from "../utils/Buttons/Buttons";
import { infoMessage } from "../api/errorHandler";
import { ConstructionOutlined } from "@mui/icons-material";
import { TextFieldStyleDummies } from "../utils/TextFieldStyle/TextFieldStyle";
import {
  coreIdCallback,
  canContinue,
  getColorsByCodeId,
  getColorsByExecFlow,
  magicFormsCallback,
  hyperFlowAsyncCallback,
} from "./hyperFlowApi";
import { useHistory } from "react-router-dom";

const HyperFlowCallback = () => {
  let history = useHistory();
  //query params
  const query = useQuery();

  const code = query.get("code") ?? "error";
  const parentId = query.get("parentExecFlowId") ?? "error";
  const execFlowId = query.get("executedFlow") ?? "error";
  const currentStep = query.get("currentStep") ?? "error";
  //State selectors

  //local states
  const [bgColor, setBgColor] = useState(["#ffffff", "#ffffff"]);
  const [darkMode, setDarkMode] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showContinueButton, setShowContinueButton] = useState(false);
  //get colors
  async function getColors() {
    let resp = await getColorsByExecFlow(execFlowId);
    setBgColor([resp.backgroundColor1, resp.backgroundColor2]);
    setDarkMode(resp.darkMode);
  }

  async function hyperFlowCallbackF() {
    setLoading(true);
    try {
      let resp = await hyperFlowAsyncCallback(code, parentId, execFlowId, currentStep);
      setShowContinueButton(resp.redirectToContinue);
    } catch (e: any) {
      console.log(e);
    }
    await delay(2000);
    setLoading(false);
  }

  function delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  useEffect(() => {
    getColors();
    hyperFlowCallbackF();
  }, []);

  const customStyle = {
    "--fontColorPrimary": darkMode ? "#ffffff" : "#000000",
  } as React.CSSProperties;

  //Render
  return (
    <div className="hfMaster" style={customStyle}>
      <div
        style={{
          background: `radial-gradient(${bgColor[0]}, ${bgColor[1]})`,
          position: "fixed",
          height: "100%",
          width: "100%",
          overflow: "auto",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "50%",
            transform: "translate(-50%, -50%)",
            left: "50%",
          }}
        >
          {loading && (
            <h1
              className="txt-label-title-hf"
              style={{ fontSize: "", marginBottom: "50px" }}
            >
              Espera un momento
            </h1>
          )}

          {!loading && (
            <div>
              <h1
                className="txt-label2"
                style={{ fontSize: "", marginBottom: "50px" }}
              >
                Tus datos están completos
              </h1>
              <h1
                className="txt-label2"
                style={{ fontSize: "", marginBottom: "50px" }}
              >
                {showContinueButton ? "Continuemos con tu proceso" : "Puedes cerrar esta ventana"}
              </h1>
              <div
                style={{
                  marginTop: "40px",
                }}
              ></div>
              {showContinueButton && (
                <ButtonStyle
                  onClick={() => {
                    history.push("/hyperFlow/continueFlow?code=" + code);
                  }}
                  text="Continuar"
                  width="177px"
                  height="5vh"
                />)}

            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HyperFlowCallback;
